import React from 'react';
import { Form, Select, InputNumber, Input } from 'antd';
import { validateCurrency } from '../../utils/validation';

const { Option } = Select;

const ExpenseFormFields = () => (
  <>
    <Form.Item
      name="name"
      label="Nome"
      className="form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Input />
    </Form.Item>
    <Form.Item
      name="value"
      label="Valor"
      className="form-item"
      rules={[
        { required: true, message: 'Campo obrigatório!' },
        { validator: validateCurrency },
      ]}
    >
      <Input />
    </Form.Item>
  </>
);

export default ExpenseFormFields;
